import Vue from 'vue';
import AnimationFade from '../../core/animation/fade/animation-fade';

export default function () {
  const partners = document.querySelector('.partners');

  if (partners) {
    new Vue({
      el: partners,
      delimiters: ['${', '}}'],
      components: {
        AnimationFade,
      },
      data: {
        manager: window.manager,
        popupIsOpen: false,
      },
      mounted() {

      },
    });
  }
}



// WEBPACK FOOTER //
// ./new-blocks/partners/partners.js